export const MOUSEOVER_COLOR = 'rgba(102, 163, 198, 0.3)';
export const MOUSEOVER_BORDER_COLOR = '#E2F1FF';
export const MOUSEOVER_BORDER_RADIUS = '0.3em';
export const ONCLICK_COLOR = 'rgba(102, 163, 198, 0.5)';
export const ON_AREASELECT_COLOR = 'rgba(102, 163, 198, 0.51)';
